import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Vision = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h2
              className="text-4xl sm:text-5xl font-bold text-white"
              style={{ letterSpacing: '0.08em' }}
            >
              Our Vision & Mission
            </h2>

            <p className="text-lg text-gray-400 leading-relaxed">
              Invotage's vision is to become America's most trusted technology partner, empowering businesses of all sizes with innovative solutions that drive real growth. Our mission is simple: deliver exceptional results through cutting-edge technology, unmatched expertise, and unwavering commitment to client success.
            </p>

            <Link to="/about">
              <Button className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-6 py-6 rounded-full group shadow-lg shadow-purple-500/50">
                Explore Our Purpose
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl shadow-purple-900/50 border border-purple-500/20">
              <img
                src="https://images.unsplash.com/photo-1519389950473-47ba0277781c"
                alt="Vision and mission"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative shapes */}
            <div className="absolute top-0 right-0 w-24 h-24 bg-purple-600/30 rounded-full opacity-50 -z-10 translate-x-12 -translate-y-12 blur-2xl"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-blue-600/30 rounded-full opacity-50 -z-10 -translate-x-12 translate-y-12 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;